import * as React from 'react'

const SvgEditUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <path
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
      d="M30 51.667h-5c-4.651 0-6.977 0-8.87.574A13.333 13.333 0 007.24 61.13c-.574 1.892-.574 4.218-.574 8.87m41.667-45c0 8.284-6.716 15-15 15-8.285 0-15-6.716-15-15 0-8.284 6.715-15 15-15 8.284 0 15 6.716 15 15zM36.667 70l10.338-2.954c.495-.141.742-.212.973-.318.205-.094.4-.209.582-.342.205-.15.387-.332.75-.697l21.524-21.522a5.893 5.893 0 10-8.334-8.334L40.977 57.356c-.363.364-.545.546-.696.751a3.33 3.33 0 00-.342.582c-.106.23-.177.478-.318.973L36.667 70z"
    ></path>
  </svg>
)

export default SvgEditUser
